import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheNightlySection } from '@news-mono/common'
import {
    getElectionToggles,
    GetRouteAdTargeting,
    LoadedElectionDefinition,
    PageType,
    Store,
} from '@news-mono/web-common'
import { createElectorateEmbedPage } from '../embeds/createElectorateEmbedPage'
import { createElectionLandingPage } from './createElectionLandingPage'
import H from 'history'

export const createSpecificElectionPage = (
    electionDefinition: LoadedElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
    location: H.Location<any>,
): PageType<TheNightlySection> | null => {
    const toggles = store.getState().toggles

    const { 'election-landing-page-route': isLandingPageEnabled } =
        getElectionToggles(electionDefinition, toggles)

    if (!isLandingPageEnabled) {
        return null
    }

    return createElectionLandingPage({
        getAdTargeting,
        electionDefinition,
        toggles,
        location,
    })
}

export const createSpecificElectionEmbedPage = (
    electionDefinition: LoadedElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
): PageType<TheNightlySection> | null => {
    const enableRoute = isFeatureEnabled(
        toFeatureState(store.getState().toggles),
        'election-widget-preview-page',
    )
    if (!enableRoute) {
        return null
    }
    const heading = `${electionDefinition.electionData.config?.electionTitle} Embed`
    const description = `An embed for the ${electionDefinition.electionData.config?.electionType.toLowerCase()} election electorate.`

    return createElectorateEmbedPage({
        heading,
        description,
        electionDefinition: electionDefinition,
        getAdTargeting,
    })
}
